const mobileFilter = document.getElementById('mobileFilter')

const mobileFilterButton = document.getElementById('mobileFilterButton')
const filterArrowStrokeColor = document.getElementById('filterArrowStrokeColor')
const filterDropdownArrow = document.getElementById('filterDropdownArrow')

const mobileSortBy = document.getElementById('mobileSortBy')
const body = document.body
const mobileSortByButton = document.getElementById('mobileSortByButton')
const arrowStrokeColor = document.getElementById('arrowStrokeColor')
const dropdownArrow = document.getElementById('dropdownArrow')

const updateBodyOverflow = () => {
    const isSortOpen = mobileSortBy && !mobileSortBy.classList.contains("x-hidden")
    const isFilterOpen = mobileFilter && !mobileFilter.classList.contains("max-md:x-hidden")

    document.body.classList.toggle("x-overflow-hidden", Boolean(isSortOpen || isFilterOpen))
}

const toggleMobileFilter = () => {
    mobileSortBy?.classList.add("x-hidden")
    mobileFilter?.classList.toggle("max-md:x-hidden")

    mobileFilterButton?.classList.toggle("x-bg-[#5B6770]")
    mobileFilterButton?.classList.toggle("x-bg-[#F7F9FB]")
    mobileFilterButton?.classList.toggle("x-text-[#5B6770]")
    mobileFilterButton?.classList.toggle("x-text-white")

    const filterCurrentStroke = filterArrowStrokeColor?.getAttribute("stroke")
    filterDropdownArrow?.classList.toggle("x-rotate-180")
    if (filterCurrentStroke === "#5B6770") {
        filterArrowStrokeColor?.setAttribute("stroke", "white")
    } else {
        filterArrowStrokeColor?.setAttribute("stroke", "#5B6770")
    }

    mobileSortByButton?.classList.remove("x-bg-[#5B6770]")
    mobileSortByButton?.classList.add("x-bg-[#F7F9FB]")
    mobileSortByButton?.classList.add("x-text-[#5B6770]")
    mobileSortByButton?.classList.remove("x-text-white")

    const currentStroke = arrowStrokeColor?.getAttribute("stroke")
    dropdownArrow?.classList.remove("x-rotate-180")
    if (currentStroke === "white") {
        arrowStrokeColor?.setAttribute("stroke", "#5B6770")
    }

    updateBodyOverflow()
}

const checkboxes = document.querySelectorAll('.SortBy-mobile');

checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', function() {
        if (this.checked) {
        checkboxes.forEach(otherCheckbox => {
            if (otherCheckbox !== this) {
                otherCheckbox.checked = false;
            }
        });
        }
    });
});

const toggleMobileSortBy = () => {
    mobileFilter?.classList.add("max-md:x-hidden")
    mobileSortBy?.classList.toggle("x-hidden")
    mobileSortByButton?.classList.toggle("x-bg-[#5B6770]")
    mobileSortByButton?.classList.toggle("x-bg-[#F7F9FB]")
    mobileSortByButton?.classList.toggle("x-text-[#5B6770]")
    mobileSortByButton?.classList.toggle("x-text-white")

    const currentStroke = arrowStrokeColor?.getAttribute("stroke")
    dropdownArrow?.classList.toggle("x-rotate-180")
    if (currentStroke === "#5B6770") {
        arrowStrokeColor?.setAttribute("stroke", "white")
    } else {
        arrowStrokeColor?.setAttribute("stroke", "#5B6770")
    }

    mobileFilterButton?.classList.remove("x-bg-[#5B6770]")
    mobileFilterButton?.classList.add("x-bg-[#F7F9FB]")
    mobileFilterButton?.classList.add("x-text-[#5B6770]")
    mobileFilterButton?.classList.remove("x-text-white")

    const filterCurrentStroke = filterArrowStrokeColor?.getAttribute("stroke")
    filterDropdownArrow?.classList.remove("x-rotate-180")
    if (filterCurrentStroke === "white") {
        filterArrowStrokeColor?.setAttribute("stroke", "#5B6770")
    }

    updateBodyOverflow()
}